import React from 'react';

const Ppt = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="128"
    height="128"
    viewBox="0 0 128 128"
  >
    <g fillRule="evenodd" clipRule="evenodd" fill="#D04524">
      <path d="M70.8 20.96v86.07c-3.55-.57-6.9-1.1-10.24-1.67-12.9-2.17-25.77-4.4-38.67-6.48-2.2-.35-3.1-1-3.1-3.46.1-20.98.1-41.98 0-62.97 0-2.2.6-3.07 2.8-3.43 15.7-2.56 31.3-5.25 47-7.88.6-.1 1.3-.1 2.1-.18zM42.45 68.9c.78-.08 1.2-.15 1.64-.16 8.4-.18 13.1-8.17 9-15.68-.8-1.36-2.4-2.94-3.8-3.1-3.8-.42-7.6-.14-11.5-.14v28.7h4.5V68.9zM92.9 85.16v-3.72H75.55c-3.28 0-3.37-.1-2.76-3.68h20v-3.92H75.6c-3.48 0-3.7-.32-2.83-3.96 9.74.66 15.74-3.35 15.07-10.4-2.9 0-5.88-.1-8.83.03-1.8.1-2.5-.5-2.4-2.4.1-2.8.1-5.6.1-8.7l-4.15.5c0-1.6-.1-3.1.05-4.6.04-.4.87-1 1.34-1 9 0 18-.1 27 .1.62 0 1.35 1.16 1.85 1.9.22.36.04 1 .04 1.54v40.6c0 3-.1 3.1-3.2 3.1-8.3 0-16.63-.07-25 .07-2.3 0-2.15-1.2-2.2-2.77-.1-1.7.24-2.55 2.25-2.5 5.26.15 10.55.06 15.83.05.72 0 1.45-.06 2.3-.1zm-14-27.6h10.4c.43-5.8-4.6-10.93-10.37-10.8v10.8z" />
      <path d="M105.1 41.24h-2.93c-9.15 0-18.3-.03-27.45.02-1.6.02-2.27-.36-2.27-2.1 0-1.73.52-2.3 2.3-2.28 10.57.07 21.13.07 31.7 0 2.08 0 2.72.84 2.7 2.8-.03 12.72 0 25.44-.06 38.17 0 .82-.5 2-1.1 2.38-1.7 1-2.9.05-2.9-2v-37zm-62.6 17.9c0-.6-.08-1.2.02-1.8.16-.93.46-2.65.67-2.65 1.4 0 3.3-.1 4.3.8 1.8 1.4 1.6 3.6 1 5.7-.6 1.9-2.1 2.5-3.9 2.7-1.5.1-2.3-.3-2.2-1.9.1-1 0-1.9 0-2.9" />
    </g>
  </svg>
);

export default Ppt;
